var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import HeaderTitle from "../../components/header-with-title";
import { Wrapper } from "./style";
import { useEffect } from "react";
import { setAuthorization, setAuthorizationProctoring } from "../../api-client";
import authService from "../../api-client/services/auth";
import { useApplicationContext } from "../../context/application-context";
import { message, Spin } from "antd";
import { CookiesExistence } from "../../submodules/Inventory-Module-Types/src/utils/storage";
import Cookies from "js-cookie";
import { useCrossOrigin } from "../../utils/cross-origin";
import { MEETING_ROUTES } from "../../constants/routes";
export const AssessmentSetup = () => {
    const metaData = useCrossOrigin();
    const navigate = useNavigate();
    console.log("metaData", metaData);
    const { auth, setUser, setAuth } = useApplicationContext();
    useEffect(() => {
        if (metaData === null || metaData === void 0 ? void 0 : metaData.interviewId) {
            getUserLoggedInStatus();
        }
    }, [metaData === null || metaData === void 0 ? void 0 : metaData.interviewId]);
    const getUserLoggedInStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const token = sessionStorage.getItem("token");
            const userId = sessionStorage.getItem("userId");
            setAuthorization(token);
            setAuthorizationProctoring(token);
            const response = yield authService.getAuthenticatedUser(token, userId);
            if (response.data) {
                const userData = response.data;
                if (!auth.userExists) {
                    setAuth({
                        userExists: true,
                        userLoading: false,
                    });
                }
                if (userData) {
                    setUser(userData);
                }
                navigate(MEETING_ROUTES.PROCTORED_INTERVIEW_GUIDELINES);
            }
            else {
                const cookieData = CookiesExistence("redirect-on-app", true);
                message.error("It seems that you have already completed the interview.");
                setAuth({
                    userExists: false,
                    userLoading: false,
                });
                if (cookieData.isExist) {
                    Cookies.remove("redirect-on-app");
                    setTimeout(() => {
                        let redirectURL = cookieData.data + "/interview-profile";
                        window.open(redirectURL, "_self");
                    }, 2000);
                }
            }
        }
        catch (error) {
            console.error("Error while fetching user in OIDC", error);
        }
    });
    return (_jsxs(Wrapper, { children: [_jsx(HeaderTitle, { title: "" }), _jsxs("div", Object.assign({ className: "container" }, { children: [_jsx("span", { children: _jsx(Spin, { size: "large" }) }), _jsxs("p", { children: ["Hold tight! We are setting up the assessment for you. ", _jsx("br", {}), "Please wait a moment..."] })] }))] }));
};
